import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { inr } from "@/lib/api";

export const PackageCard = ({ p, i = 0, tall }) => (
  <Link to={`/packages/${p.slug}`} data-testid={`package-card-${p.slug}`}
    className="group zoom lift relative block overflow-hidden rounded-2xl bg-[#0D1B2A] fade-up"
    style={{ animationDelay: `${i * 70}ms` }}>
    <img src={p.image} alt={p.name} className={`w-full object-cover ${tall ? "h-[26rem]" : "h-80"}`} loading="lazy" />
    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/25 to-transparent" />
    <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-[#0D1B2A]">
      {p.region === "domestic" ? "India" : p.country}
    </span>
    <span className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full bg-[#E07A5F] text-white opacity-0 transition-opacity group-hover:opacity-100">
      <ArrowUpRight className="h-4 w-4" />
    </span>
    <div className="absolute inset-x-0 bottom-0 p-5 text-white">
      <p className="text-xs text-slate-300">{p.location}</p>
      <h3 className="font-display text-2xl font-bold leading-tight">{p.name}</h3>
      <div className="mt-3 flex items-end justify-between">
        <span className="flex items-center gap-1.5 text-xs text-slate-300"><Clock className="h-3.5 w-3.5" />{p.days} days</span>
        <span className="text-right">
          <span className="block text-[10px] uppercase tracking-wider text-slate-400">from</span>
          <span className="text-lg font-bold text-[#F4A261]" data-testid={`package-price-${p.slug}`}>{inr(p.price)}</span>
        </span>
      </div>
    </div>
  </Link>
);
